export function debounce(cb, timeout = 0, instant = true) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        if (timeout === 0 && instant) {
            cb(...args);
        }
        else {
            timer = setTimeout(() => cb(...args), timeout);
        }
    };
}
export function throttle(cb, timeout) {
    let timer;
    return (...args) => {
        if (timer) {
            return;
        }
        timer = setTimeout(() => {
            cb(...args);
            timer = null;
        }, timeout);
    };
}
export const noop = () => { };
//# sourceMappingURL=function.js.map